import styled, { css } from 'styled-components';

export const AddContainer = styled.div`
  height: 24px;
  width: 24px;
  background: #d9d9d9;
  display: flex;
  justify-content: center;
  color: #0000008a;
  align-items: center;
`;

export const TileOverview = styled.div<{
  isPremiumOnly: boolean;
  isSelected: boolean;
}>`
  display: flex;

  padding: 13px 14px;
  position: relative;
  background-color: #ffffff;

  ${props => {
    if (props.isPremiumOnly) {
      return css`
        opacity: 0.5;
        background-color: #eeeeee;

        &:hover {
          ${AddContainer} {
            background: #bed600;
            color: #ffffff;
          }
        }
      `;
    } else if (props.isSelected) {
      return css`
        opacity: 0.7;
        background-color: #eeeeee;
        ${AddContainer} {
          background: #bed600;
          color: #ffffff;
        }
      `;
    } else {
      return css`
        &:hover {
          background-color: #eeeeee;
          cursor: pointer;

          button {
            background-color: #bed600;
            color: #e1ec8a;
          }

          ${AddContainer} {
            background: #bed600;
            color: #ffffff;
          }
        }
      `;
    }
  }}
`;

export const Image = styled.img`
  width: 55px;
  height: 55px;
`;

export const Content = styled.div`
  color: #000000;
  padding: 0 14px;
  width: 220px;
  margin-top: -5px;
`;

export const Name = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 500;
`;

export const Description = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
`;

export const Button = styled.button`
  background-color: #d9d9d9;
  color: #646464;
  border: none;
  width: 24px;
  height: 24px;
  position: absolute;
  right: 14px;
  top: 17px;
  font-size: 20px;
  cursor: pointer;
`;

export const View = styled.div`
  width: 354px;
`;
